// export const WHITE_LIST = [
//   { name: 'notFound', children: [] },
//   { name: 'login', children: [] },
// ];

// export const NOT_FOUND = {
//   name: 'notFound',
// };
export const REDIRECT_ROUTE_NAME = 'Redirect';

export const DEV_ROUTE_NAME = 'TemporaryTemplate';

export const DEFAULT_ROUTE_NAME = 'GoodsPlan';
export const DEFAULT_ROUTE = {
  title: '商品企划',
  name: DEFAULT_ROUTE_NAME,
  fullPath: '/develop/goods-plan',
};

export const DEFAULT_ROUTE_NAME_PRO = 'GoodsPlanPro';
export const DEFAULT_ROUTE_PRO = {
  title: '商品企划',
  name: DEFAULT_ROUTE_NAME_PRO,
  fullPath: '/develop-pro/goods-plan-pro',
};
